export default {
  selection: "System Language Selection",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "Английский",
    zh: "Китайский (КНР)",
    tw: "Китайский (Тайвань)",
    vi: "Вьетнамский",
    th: "Тайский",
    id: "Индонезийский",
    malay: "Малайский",
    jp: "Японский",
    kr: "Корейский",
    my: "Бирманский",
    ar: "Аргентина",
    ru: "Россия",
    ne: "непальский",
    bn: "Бенгальский"
  }
};
